export const ACCORDION_SECTION_VALUE = "section";
